import { Component } from '@angular/core';
import { SidebarService } from '../../../core/services/sidebar/sidebar.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-sidebar-group',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './sidebar-group.component.html',
  styleUrl: './sidebar-group.component.scss'
})
export class SidebarGroupComponent {
  constructor(private sidebarService: SidebarService) {}

  onClose(){
    this.sidebarService.setSidebarState(false);
  }
}
